var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBr = function SvgBr(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21786_20571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21786_20571)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#359C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99922 2.80078L20.7992 10.0008L9.99922 17.2008L-0.800781 10.0008L9.99922 2.80078Z",
    fill: "#FDD346"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0003,
    cy: 9.99994,
    rx: 4.41045,
    ry: 4.41009,
    fill: "#3B309F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4311 10.4752C11.613 8.0798 8.79498 7.65684 5.97691 8.00934C5.83601 8.15049 5.80078 8.53763 5.80078 8.71356C11.0847 8.18522 13.0221 10.2988 14.255 11.1794C14.4311 10.8272 14.4311 10.5925 14.4311 10.4752Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9987 11L13.0361 11.1152H13.1572L13.0592 11.1863L13.0967 11.3015L12.9987 11.2303L12.9007 11.3015L12.9382 11.1863L12.8402 11.1152H12.9613L12.9987 11Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9987 11.834L13.0361 11.9492H13.1572L13.0592 12.0203L13.0967 12.1355L12.9987 12.0643L12.9007 12.1355L12.9382 12.0203L12.8402 11.9492H12.9613L12.9987 11.834Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5846 12.084L12.6221 12.1992H12.7431L12.6452 12.2703L12.6826 12.3855L12.5846 12.3143L12.4867 12.3855L12.5241 12.2703L12.4261 12.1992H12.5472L12.5846 12.084Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 12.666L11.2041 12.7812H11.3252L11.2272 12.8524L11.2646 12.9675L11.1667 12.8964L11.0687 12.9675L11.1061 12.8524L11.0082 12.7812H11.1292L11.1667 12.666Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8253 11.5497L12.7042 11.5511L12.6681 11.6667L12.6294 11.552L12.5083 11.5534L12.6055 11.4811L12.5667 11.3663L12.6655 11.4364L12.7626 11.3641L12.7265 11.4797L12.8253 11.5497Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3683 11.7587L12.2472 11.7601L12.2111 11.8757L12.1724 11.761L12.0513 11.7623L12.1484 11.69L12.1097 11.5753L12.2085 11.6454L12.3056 11.5731L12.2695 11.6887L12.3683 11.7587Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9987 10L7.03612 10.1152H7.15721L7.05924 10.1863L7.09666 10.3015L6.9987 10.2303L6.90073 10.3015L6.93815 10.1863L6.84019 10.1152H6.96128L6.9987 10Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82532 10.5497L6.70423 10.5511L6.66814 10.6667L6.6294 10.552L6.50832 10.5534L6.60546 10.4811L6.56673 10.3663L6.6655 10.4364L6.76264 10.3641L6.72654 10.4797L6.82532 10.5497Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36828 10.7587L6.2472 10.7601L6.2111 10.8757L6.17237 10.761L6.05129 10.7623L6.14843 10.69L6.10969 10.5753L6.20847 10.6454L6.30561 10.5731L6.26951 10.6887L6.36828 10.7587Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 10.543L10.0361 10.6581H10.1572L10.0592 10.7293L10.0967 10.8445L9.9987 10.7733L9.90073 10.8445L9.93815 10.7293L9.84019 10.6581H9.96128L9.9987 10.543Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 8L11.2041 8.11517H11.3252L11.2272 8.18635L11.2646 8.30152L11.1667 8.23034L11.0687 8.30152L11.1061 8.18635L11.0082 8.11517H11.1292L11.1667 8Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58464 10.793L9.62205 10.9081H9.74314L9.64518 10.9793L9.6826 11.0945L9.58464 11.0233L9.48667 11.0945L9.52409 10.9793L9.42613 10.9081H9.54722L9.58464 10.793Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 13L9.20409 13.1152H9.32518L9.22721 13.1863L9.26463 13.3015L9.16667 13.2303L9.0687 13.3015L9.10612 13.1863L9.00816 13.1152H9.12925L9.16667 13Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58073 12L7.61815 12.1152H7.73924L7.64127 12.1863L7.67869 12.3015L7.58073 12.2303L7.48276 12.3015L7.52018 12.1863L7.42222 12.1152H7.54331L7.58073 12Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 12.25L7.20409 12.3652H7.32518L7.22721 12.4363L7.26463 12.5515L7.16667 12.4803L7.0687 12.5515L7.10612 12.4363L7.00816 12.3652H7.12925L7.16667 12.25Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16667 11L7.20409 11.1152H7.32518L7.22721 11.1863L7.26463 11.3015L7.16667 11.2303L7.0687 11.3015L7.10612 11.1863L7.00816 11.1152H7.12925L7.16667 11Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82532 10.2587L9.70423 10.2601L9.66814 10.3757L9.6294 10.261L9.50832 10.2623L9.60546 10.19L9.56673 10.0753L9.6655 10.1454L9.76264 10.0731L9.72654 10.1887L9.82532 10.2587Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36828 10.4677L9.2472 10.4691L9.2111 10.5847L9.17237 10.4699L9.05129 10.4713L9.14843 10.399L9.10969 10.2843L9.20847 10.3543L9.30561 10.282L9.26951 10.3976L9.36828 10.4677Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8683 12.2587L11.7472 12.2601L11.7111 12.3757L11.6724 12.261L11.5513 12.2623L11.6484 12.19L11.6097 12.0753L11.7085 12.1454L11.8056 12.0731L11.7695 12.1887L11.8683 12.2587Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8683 12.7587L11.7472 12.7601L11.7111 12.8757L11.6724 12.761L11.5513 12.7623L11.6484 12.69L11.6097 12.5753L11.7085 12.6454L11.8056 12.5731L11.7695 12.6887L11.8683 12.7587Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3683 12.5907L12.2472 12.5921L12.2111 12.7077L12.1724 12.593L12.0513 12.5944L12.1484 12.5221L12.1097 12.4073L12.2085 12.4774L12.3056 12.4051L12.2695 12.5207L12.3683 12.5907Z",
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/br.822a4de2486c98655b9aa12a6812d9d4.svg";